import API from '@/shared/plugins/Api/API'
import Attributes from './Attributes'
import Databases from './Databases'
import Datasets from './Datasets'
import Instances from './Instances'
import Jobs from './Jobs'
import LogicalAttributes from './LogicalAttributes'
import LogicalObjects from './LogicalObjects'
import LogicalReferentials from './LogicalReferentials'
import Metas from './Metas'
import Rules from './Rules'
import RowFilters from './RowFilters'
import SqlViews from './SqlViews'
import Tabs from './Tabs'
import VirtualAttributes from './VirtualAttributes'
import PolicyTags from './PolicyTags'
import SharedAttributes from './SharedAttributes'
import SnapshotTimeTravelCollections from './SnapshotTimeTravelCollections'
import Consumers from './Consumers'
import TrinoConnectors from './TrinoConnector'
import CustomSources from './CustomSources'

class DM extends API {
  constructor (id) {
    super(id)
    this.consumers = new Consumers(id)
    this.jobs = new Jobs(id)
    this.databases = new Databases(id)
    this.datasets = new Datasets(id)
    this.attributes = new Attributes(id)
    this.instances = new Instances(id)
    this.rules = new Rules(id)
    this.rowFilters = new RowFilters(id)
    this.sqlViews = new SqlViews(id)
    this.tabs = new Tabs(id)
    this.metas = new Metas(id)
    this.logicalObjects = new LogicalObjects(id)
    this.logicalReferentials = new LogicalReferentials(id)
    this.logicalAttributes = new LogicalAttributes(id)
    this.virtualAttributes = new VirtualAttributes(id)
    this.policyTags = new PolicyTags(id)
    this.sharedAttributes = new SharedAttributes(id)
    this.snapshotTimeTravelCollections = new SnapshotTimeTravelCollections(id)
    this.trino_connectors = new TrinoConnectors(id)
    this.customSources = new CustomSources(id)
  }

  async workflowBuilder (repository, repository_version, tables = null) {
    const res = await this.request({
      url: 'v4/workflow_builder',
      params: {
        tables: JSON.stringify(tables),
        repository,
        repository_version
      }
    })
    return res
  }

  async physicalBuild (objects) {
    return await this.request({
      method: 'put',
      socketId: false,
      url: 'v4/build/start',
      data: {
        objects
      }
    })
  }

  async stopPhysicalBuild () {
    return await this.request({
      method: 'delete',
      url: 'v4/build/stop'
    })
  }

  async metrics () {
    return await this.request({
      url: 'v4/metrics'
    })
  }

  async import (item) {
    return this.request({
      method: 'POST',
      url: 'v4/backup/import',
      data: item,
      timeout: 60 * 10 * 1000
    })
  }

  // GET the configuration archive as a blob so the download happens in-app (with progress feedback).
  async exportConfiguration () {
    return this.request({
      method: 'GET',
      url: 'v4/configuration/export',
      responseType: 'blob',
      originalResponse: true,
      timeout: 60 * 10 * 1000
    })
  }

  // Mirror of the export endpoint (GET v4/configuration/export) used on the project home tiles.
  async importConfiguration (file) {
    const formData = new FormData()
    formData.append('archive', file)
    return this.request({
      method: 'POST',
      url: 'v4/configuration/import',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60 * 10 * 1000
    })
  }

  async health (item) {
    return this.request({
      method: 'GET',
      url: 'health'
    })
  }

  templatesActionsAggregate (source, destination, action) {
    return this.request({
      method: 'GET',
      url: '/v4/aggregate_template',
      params: {
        source_db: source.database_name,
        source: source.table_name,
        destination_db: destination.database_name,
        destination: destination.table_name,
        action: action
      }
    })
  }
}
export default DM
